import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UPDATE_HOLIDAY, CREATE_HOLIDAY,DELETE_HOLIDAY,GET_HOLIDAY } from "../Queries/Holiday";
import { client } from '..';
import { setLoader } from "./loaderSlice";

const initialState = {
    holiday: []
}
const holidaySlice = createSlice({
    name: "holiday",
    initialState,
    reducers: {
        addHoliday: (state, action) => {
            state.holiday.push(action.payload)
        },
        getHoliday: (state, action) => {
            // console.log("action.payload",action.payload)
            state.holiday = action.payload;
        }

    },
    extraReducers: (builder) =>{
        builder
        .addCase(fetchHolidays.fulfilled,(state,action)=>{
            state.holiday = action.payload
        })
    }
});

export const createHoliday = createAsyncThunk(
    'holidays/createHoliday',
    async ({ name, department, date, type }, { rejectWithValue }) => {
        try {
            const response = await client.mutate({
                mutation: CREATE_HOLIDAY,
                variables: { name, department, date,type },
            });
            const result = response.data?.CreateHoliday;

            if (!result || result.status !== 200) {
                return rejectWithValue(result?.message || 'Failed to submit holiday.');
            }

            return {
                message: result.message,
                holidays: result.holidays,
                status: result.status,
            };
        } catch (error) {
            return rejectWithValue('Failed to submit holiday. Please try again.');
        }
    }
);


export const updateHoliday = createAsyncThunk(
    'holidays/updateHoliday',
    async ({ id, name, department, date, type }, { rejectWithValue }) => {
        try {
            const response = await client.mutate({
                mutation: UPDATE_HOLIDAY,
                variables: { id, name, department, date, type },
            });

            const result = response.data?.UpdateHoliday;

            if (!result || result.status !== 200) {
                return rejectWithValue(result?.message || 'Failed to update holiday.');
            }

            return {
                message: result.message,
                holidays: result.holidays,
                status: result.status,
            };
        } catch (error) {
            return rejectWithValue('Failed to update holiday. Please try again.');
        }
    }
);


export const deleteHoliday = createAsyncThunk(
    'holidays/deleteHoliday',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await client.mutate({
                mutation: DELETE_HOLIDAY,
                variables: { id },
            });

            const result = response.data?.DeleteHoliday;

            if (!result) {
                return rejectWithValue('Failed to delete holiday.');
            }

            return {
                message: `${result.name} deleted successfully`,
                id, // return the deleted holiday's id to remove it from state
            };
        } catch (error) {
            return rejectWithValue('Failed to delete holiday. Please try again.');
        }
    }
);


export const fetchHolidays = createAsyncThunk(
    'holidays/fetchHolidays',
    async ({ department, role }, { dispatch,rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const response = await client.query({
                query: GET_HOLIDAY,
                variables: { department, role },
                fetchPolicy: 'network-only', // ensures fresh data from the server
            });

            const result = response.data?.GetHoliday;

            if (!result) {
                return rejectWithValue('Failed to fetch holidays.');
            }

            return result; // return the array of holidays
        } catch (error) {
            return rejectWithValue('Failed to fetch holidays. Please try again.');
        }
        finally{
            dispatch(setLoader(false))
        }
    }
);

export const { addHoliday } = holidaySlice.actions;

export default holidaySlice.reducer;